<template>
    <div :class="{'contract-edit': editorOpen}">
        <div class="rules__header rules__header-staff">
            <div class="text-size-ml text-bold rules__header-wrapper">
                <div class="rules__header-left">
					<span class="ts-name --staff">
						<span>договора</span>
						<div class="count">
							{{ userTotal }}
						</div>
					</span>
                </div>
                <div class="rules__header-right " v-if="!editorOpen">
					<span class="ss-name back elem-pos-fix" @click="goToList()">
						<span class="i i-arrow mr8"></span> {{ contractDetail.title }}
					</span>
                    <div class="btns rule-detail__btns">
                        <span class="copy editor-btn has-hover has-hint mr8 "
                              @click.stop="copy($event)">
                            <span class="i-wrapper">
                                <span class="i i-copy4"></span>
                                <span class="i i-copy4-active actv"></span>
                                <span class="i i-ok3"></span>
                            </span>
                            <span class="hint bottom-center-direction">Скопировать ссылку</span>
                        </span>
                        <span @click="deleteContract()" class="remove editor-btn has-hint has-hover mr8" v-if="(userCurrent.is_can_contract || userCurrent.access_rights.is_owner)">
                            <div class="has-hint">
                                <span class="i-wrapper">
                                    <span class="i i-trash6"></span>
                                    <span class="i i-trash6-active actv"></span>
                                </span>
                                <span class="hint bottom-center-direction">Удалить договор</span>
                            </div>
                        </span>
                        <div @click="setEditorOpen(true)" v-if="(userCurrent.is_can_contract || userCurrent.access_rights.is_owner)"
                                class="edit editor-btn has-hover has-hint mr8">
                            <span class="i-wrapper">
                                <span class="i i-pencil"></span>
                                <span class="i i-pencil-active actv"></span>
                            </span>
                            <span class="hint bottom-center-direction">Редактировать</span>
                        </div>
						<span class="remove editor-btn has-hint has-hover mr8"  @click="preview();">
                            <div class="has-hint">
                                <span class="i-wrapper">
                                    <span class="i i-preview"></span>
                                    <span class="i i-preview-active actv"></span>
                                </span>
                                <span class="hint bottom-center-direction">Предварительный просмотр</span>
                            </div>
                        </span>
                    </div>
					<div class="">

					</div>
                </div>
                <div class="rules__header-right" v-else-if="(userCurrent.is_can_contract || userCurrent.access_rights.is_owner)">
                    <div class="btns">
                        <span class="editor-btn mr4 has-hint" @click="action('h2')">
                            <span class="i-wrapper text-size-ms">
                                H2
                            </span>
                            <span class="hint bottom-center-direction">Малый заголовок</span>
                        </span>
                        <span class="editor-btn mr4 has-hint" @click="action('ol')">
                            <span class="i-wrapper">
                                <span class="i i-list"></span>
                            </span>
                            <span class="hint bottom-center-direction">Список с номерами</span>

                        </span>
                        <span class="editor-btn mr4 has-hint" @click="action('ul')">
                            <span class="i-wrapper">
                                <span class="i i-marker-list"></span>
                            </span>
                            <span class="hint bottom-center-direction">Список с буллитами</span>

                        </span>
                        <editor-menu-bar v-if="editor" :editor="editor" v-slot="{ commands }">
                            <span :class="{'is-active': editor.isActive.bold() }" class="editor-btn mr4 has-hint" @click="commands.bold">
                                <span class="i-wrapper">
                                    <span class="i i-bold"></span>
                                </span>
                                <span class="hint bottom-center-direction">Жирный</span>
                            </span>
                        </editor-menu-bar>
                        <span v-else class="editor-btn mr4 has-hint">
                            <span class="i-wrapper">
                                <span class="i i-bold"></span>
                            </span>
                            <span class="hint bottom-center-direction">Жирный</span>
                        </span>
                    </div>
					<div @click="action('preview');" type="button" name="button" class="rules__btn"><span class="i i-preview mr8" style="margin-top: -2px"></span>Предварительный просмотр</div>
					<div @click="action('save')" class="rules__btn-yellow btn btn--ico save"
                         :class="{'load': saveLoader, 'rules__btn-disabled':disableSave}">
                        <svg class="btn-preloader mr8">
                            <use xlink:href="@/assets/img/big-icons-sprite.svg#preloader"></use>
                        </svg>
                        <span class="i i-save3 mr8"></span>
                        Сохранить
                    </div>
                    <div @click="closeEditor()" class="i i-close10" ></div>
                </div>
            </div>
        </div>
        <div class="content moderator-rules">
            <div class="container staff-container">

                <aside-sticky :marginTop="88" :marginBottom="0">
                    <aside class="aside aside--left aside--catalog">
                        <div class="aside__sticky" id="aside-sticky">
                            <div class="nav nav--city">
                                <div class="nav-wrapper" v-if="contractsGrouped.length">
                                    <draggable :forceFallback="true"
                                               :disabled="(!canDrag || editorOpen) && !userCurrent.access_rights.is_owner"
                                               element="ul"
                                               v-model="contractsGrouped"
                                               :move="dragStatus"
                                               @end="dragSaveGrouped"
                                               :animation="150"
                                               :touchStartThreshold="3"
                                               :delay="10"
                                               v-if="!editorOpen"
                                               class="nav-list">
                                        <li class="nav-list-item" v-for="(department, index) in contractsGrouped"
                                            :key="department.id">
                                            <a href="javascript:void(0)"
                                               @mouseup="setUsersGroupedCurrentIndex(department.id)"
                                               class="nav-list-item-link"
                                               :class="{active: department.id == contractsGroupedCurrent.id && contractsGroupedCurrentIndex !== 'dismiss', 'can-hover': false, 'current': false }">
                                                <span class="cat-name">{{ department.name }}</span>
                                            <span v-if="tumblers.staffEditable.value  && userCurrent.access_rights.is_owner && !editorOpen"
                                                      class="i-wrapper edit-btn" @click="openStaffGroup(department)">
				                              <span class="i i-pencil2" @click.prevent=""></span>
				                              <span class="i i-pencil2-active" @click.prevent=""></span>
				                          </span>
                                                <div class="count" v-else>
                                                    {{ department.contracts ? department.contracts.length : 0 }}
                                                </div>
                                            </a>
                                        </li>
                                    </draggable>
                                    <template v-else>
                                        <li class="nav-list-item" v-for="(department, index) in contractsGrouped"
                                            :key="department.id">
                                            <a href="javascript:void(0)"
                                               @mouseup="setUsersGroupedCurrentIndex(department.id)"
                                               class="nav-list-item-link"
                                               :class="{active: department.id == contractsGroupedCurrent.id && contractsGroupedCurrentIndex !== 'dismiss', 'current': department.id == contractDetail.group }">
                                                <span class="cat-name">{{ department.name }}</span>
                                                <div class="count">
                                                    {{ department.contracts ? department.contracts.length : 0 }}
                                                </div>
                                            </a>
                                        </li>
                                    </template>
                                    <div class="nav-list-item">
                                        <a href="javascript:void(0)" @mouseup="setUsersGroupedCurrentIndex('dismiss')"
                                           class="nav-list-item-link"
                                           :class="{active: contractsGroupedCurrentIndex == 'dismiss', 'can-hover': false, 'current': false }">
                                            <span class="cat-name">Заблокированные</span>
                                            <div class="count">
                                                {{ deleted.length }}
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div class="add-section__wrap" @click="openStaffGroup">
                                    <div class="add-section">
                                        <span class="i i-plus8"></span>
                                        <span class="i i-plus8-active"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </aside>
                </aside-sticky>

                <div class="container__full container-scroll container__right container__contract container__staff">
                    <div style="height: 40px;"></div>
                    <contract-editor
                            @editor="editorSet"
                            :contractDetail="contractDetail"
                            v-if="editorOpen && (userCurrent.is_can_contract || userCurrent.access_rights.is_owner)"
                            @save="save"
                            @is_edit="setIsEdit"
                            @load="saveLoader = true"
                            @disableSave="disableSave = $event"
                            ref="contractEditor"></contract-editor>
                    <contract-detail-text v-else-if="contractDetail.id" :contractData="contractDetail"></contract-detail-text>
                </div>
            </div>
        </div>
        <popup :is-set-styled="false" :show="popups.staffGroup.show" :name="popups.staffGroup.name" :width="400"
               :add-class="'add-cat'">
            <staff-group></staff-group>
        </popup>

        <popup :is-set-styled="false" :is-btn-close="false" :show="popups.removeStaffGroupError.show"
               :name="popups.removeStaffGroupError.name" :width="400">
            <remove-staff-group-error></remove-staff-group-error>
        </popup>

        <popup :is-set-styled="false" :show="popups.addWorker.show" :name="popups.addWorker.name" :width="800"
               :add-class="'add-worker'">
            <add-worker :contractsGroupedCurrentIndex="contractsGroupedCurrentIndex"
                        @change="setUsersGroupedCurrentIndex"></add-worker>
        </popup>

        <popup :is-set-styled="false" :show="popups.dismissWorker.show" :name="popups.dismissWorker.name" :width="430">
            <dismiss-worker></dismiss-worker>
        </popup>

        <popup :is-set-styled="false" :is-btn-close="true" :show="popups.kickUnReadAll.show"
               :name="popups.kickUnReadAll.name" :width="400">
            <kick-un-read-all></kick-un-read-all>
        </popup>

        <popup :is-set-styled="false" :show="popups.previewPDF.show" :name="popups.previewPDF.name" :width="940" :add-class="'contract-preview'">
            <iframe v-if="popups.previewPDF.show" width="840" height="1200" :src="appPath+contractDetail.pdf" frameborder="0"></iframe>
        </popup>
        <popup :is-set-styled="false" :show="popups.exitWithoutSave.show" :name="popups.exitWithoutSave.name"
               :width="512">
            <exit-without-save @apply="isEdit=false;closeEditor()"/>
        </popup>
        <!-- В данный момент редактирования недоступно -->
        <popup :is-set-styled="false" :show="popups.editDisabled.show" :name="popups.editDisabled.name" :width="512"
               :is-btn-close="false">
            <edit-disabled></edit-disabled>
        </popup>

        <!-- В данный момент удаление недоступно -->
        <popup :is-set-styled="false" :show="popups.removeDisabled.show" :name="popups.removeDisabled.name"
               :width="512" :is-btn-close="false">
            <remove-disabled></remove-disabled>
        </popup>
        <!-- В данный момент удаление недоступно -->
        <popup :is-set-styled="false" :show="popups.removeContract.show" :name="popups.removeContract.name" :width="512">
            <remove-contract></remove-contract>
        </popup>
    </div>
</template>


<script>
import {mapState} from 'vuex';
import Popup from '@/components/modal/Popup.vue';
import StaffGroup from '@/components/modal/rules/StaffGroup.vue';
import RemoveStaffGroupError from '@/components/modal/rules/RemoveStaffGroupError.vue';
import KickUnReadAll from '@/components/modal/rules/KickUnReadAll.vue';
import AddWorker from '@/components/modal/rules/AddWorker.vue';
import Tooltip from '@/components/Tooltip.vue';
import draggable from '@/helpers/vuedraggable.js';
import DismissWorker from '@/components/modal/rules/DismissWorker.vue';
import SubmitBtn from '@/components/forms/SubmitBtn.vue';
import Tumbler from '@/components/Tumbler.vue';
import AsideSticky from '@/components/AsideSticky.vue';
import ContractEditor from '@/components/ContractEditor.vue';
import ContractDetailText from '@/components/contract/ContractDetail.vue';
import { EditorMenuBar } from 'tiptap'
import {copyTextToClipboard} from "@/helpers/util/helper";
import ExitWithoutSave from '@/components/modal/rules/ExitWithoutSave.vue';
import EditDisabled from '@/components/modal/rules/EditDisabled.vue';
import RemoveDisabled from '@/components/modal/rules/RemoveDisabled.vue';
import RemoveContract from '@/components/modal/rules/RemoveContract.vue';

export default {
    metaInfo() {
        return {
            title: 'ДОГОВОРА',
            titleTemplate: this.$store.state.options.titleTemplate
        }
    },
    name: "ContractDetail",
    components: {
        Popup,
        StaffGroup,
        RemoveStaffGroupError,
        Tooltip,
        draggable,
        AddWorker,
        DismissWorker,
        SubmitBtn,
        Tumbler,
        KickUnReadAll,
        AsideSticky,
        ContractEditor,
        ContractDetailText,
        EditorMenuBar,
        ExitWithoutSave,
        EditDisabled,
        RemoveDisabled,
        RemoveContract,
    },
    data: function () {
        return {
            drag: false,
            curDrugGroupIndex: 0,
            btnType: 'normal',
            kickUnReadAllBtnType: 'normal',
            kickActive: false,
            saveLoader: false,
			logActive: false,
            contractDetail: {},
            editor: false,
            appPath: process.env.VUE_APP_PATH_BACK,
            disableSave: false,
            isEdit: false,
        }
    },
    computed: {
        ...mapState({
            popups: state => state.popups.items,
            topSections: state => state.rules.topSectionsStaff,
            tumblers: state => state.rules.tumblers,
            canDrag: state => state.rules.canDrag,
            deleted: state => state.contracts.deleted,
            userCurrent: state => state.users.user,
            editorOpen: state => state.contracts.editorOpen,
        }),
        contractsGroupedCurrentIndex(){
            return  this.$route.params.sid ? this.$route.params.sid : 0
        },
        contractsGroupedCurrent(){
            let group = {
                contracts: []
            };
            if(this.contractsGroupedCurrentIndex == 'deleted'){
                group.contracts = this.deleted;
                group.name = 'Удаленные';
                group.id = 'deleted';
            } else {
                for(let g in this.contractsGrouped){
                    if(!group.id){
                        group = this.contractsGrouped[g]
                    }
                    if(this.contractsGrouped[g].id == this.contractsGroupedCurrentIndex ){
                        group = this.contractsGrouped[g]
                    }
                }
            }

            return group
        },
        contractsGrouped:{
            set(value) {
                this.$store.dispatch('contracts/setGroupSort', value);
            },
            get() {
                return this.$store.state.contracts.items;
            }
        },
        userTotal(){
            let total = 0;
            for(let g in this.contractsGrouped){
                total += this.contractsGrouped[g].contracts ? this.contractsGrouped[g].contracts.length : 0
            }
            return total;
        }
    },
    methods: {
        setEditorOpen(value){
            if(value){
                if(this.$route.params.id === 'new'){
                    this.$store.commit('contracts/setEditorOpen', value);
                    this.$store.commit('rules/tumblerOff', 'staffEditable');
                } else {
                    this.$store.dispatch('contracts/checkEditItem',this.contractDetail).then((res)=>{
                        if(res.status){
                            this.$store.dispatch('popups/open', {name: this.popups.editDisabled.name});
                        } else {
                            this.$store.commit('contracts/setEditorOpen', value);
                            this.$store.commit('rules/tumblerOff', 'staffEditable');
                        }
                    })
                }
            } else {
                this.$store.commit('contracts/setEditorOpen', value);
            }


        },
        openStaffGroup: function (group = []) {
            this.$store.commit('rulesStaff/setEditGroup', group);
            this.$store.dispatch('popups/open', {name: this.popups.staffGroup.name});
        },
        dragSaveGrouped: function () {
            if (this.drag) {
                this.drag = false;
            }
        },
        dragStatus: function (e) {
            this.drag = true;
        },
        setUsersGroupedCurrentIndex(index) {
            if(!this.editorOpen){
                this.$router.push('/staff/contract/'+index+'/');
            } else if(index !== 'dismiss') {
                this.$router.push('/staff/contract/'+index+'/'+this.$route.params.id+'/');
            }
        },
        deleteContract(){
            this.$store.dispatch('contracts/checkEditItem',this.contractDetail).then((res)=>{
                if(res.status){
                    this.$store.dispatch('popups/open', {name: this.popups.removeDisabled.name});
                } else {
                    this.$store.dispatch('popups/open', {name: this.popups.removeContract.name});
                }
            })
        },
        action(type){
            if(this.$refs.contractEditor){
                switch (type) {
                    case 'h2':
                        this.$refs.contractEditor.pushSection();
                        break;
                    case 'ol':
                        this.$refs.contractEditor.pushOL();
                        break;
                    case 'ul':
                        this.$refs.contractEditor.pushUL();
                        break;
                    case 'b':
                        this.$refs.contractEditor.bold();
                        break;
                    case 'save':
                        if(!this.disableSave){
                            this.$refs.contractEditor.save(true);
                        }
                        break;
                    case 'preview':
                        this.$refs.contractEditor.preview();
                        break;
                }
            }

        },
        closeEditor(){
            if(this.isEdit){
                this.$store.dispatch('popups/open', {name: this.popups.exitWithoutSave.name});
            } else {
                if(this.$route.params.id === 'new'){
                    this.$router.push('/staff/contract/'+this.$route.params.sid+'/');
                    this.contractDetail = {};
                    this.setEditorOpen(false);
                }
                else{
                    this.$store.dispatch('contracts/getItem',{id:this.$route.params.id}).then((item)=>{
                        this.contractDetail = item;
                        this.setEditorOpen(false);
                    })
                }
            }
        },
        goToList(){
            this.setEditorOpen(false);
            this.$router.push('/staff/contract/'+this.contractsGroupedCurrent.id);
        },
        save(item){
            this.saveLoader=false;
            this.setEditorOpen(false);
            this.contractDetail = item;
        },
        editorSet(editor){
            this.editor = editor
        },
        copy(e){
            let text = process.env.VUE_APP_PATH_BACK + "/contract/?id=" + this.contractDetail.publicId;
            if (e.target.classList.contains('i')) {
                e.target.parentElement.classList.add('copied');
                setTimeout(function () {
                    e.target.parentElement.classList.remove('copied');
                }, 500);
            } else {
                e.target.classList.add('copied');
                setTimeout(function () {
                    e.target.classList.remove('copied');
                }, 500);
            }
            copyTextToClipboard(text);
        },
        preview(){
            this.$store.dispatch('popups/open', {name: this.popups.previewPDF.name});
        },
        setIsEdit(value){
            this.isEdit = value;
        }
    },
    mounted() {
        if(this.contractsGrouped.length === 0){
            this.$store.dispatch('contracts/getItems').then(()=>{
                if(this.$route.params.id !== 'new'){
                    this.$store.dispatch('contracts/getItem',{id:this.$route.params.id}).then((item)=>{
                        this.contractDetail = item;
                    })
                }

            });
        } else if(this.$route.params.id !== 'new') {
            this.$store.dispatch('contracts/getItem',{id:this.$route.params.id}).then((item)=>{
                this.contractDetail = item;
            })
        }

        if(this.$route.params.id === 'new'){
            this.setEditorOpen(true);
        } else  {
            this.setEditorOpen(false);
        }
    },
    beforeDestroy() {
        this.$store.commit('contracts/setEditorOpen', false);
    }
}
</script>
